import React from 'react';
import Header from "../Sub/Header";
import Footer from "../Sub/Footer";

const blogData = [
  {
    title: 'Tax Saving Tips for Freelancers in India in 2024: Maximise Your Savings',
    description: "Have you ever had a look at your payslip and wondered where a portion of hard-earned money disappears every month?",
    image: 'https://d17x24txz4ixmz.cloudfront.net/blog/tax-saving-tips-for-freelancers-in-india.webp',
    link: '#'
  },
  {
    title: 'Tax Saving Tips for Freelancers in India in 2024: Maximise Your Savings',
    description: "Have you ever had a look at your payslip and wondered where a portion of hard-earned money disappears every month?",
    image: 'https://d17x24txz4ixmz.cloudfront.net/blog/tax-saving-tips-for-freelancers-in-india.webp',
    link: '#'
  },
  {
    title: 'Tax Saving Tips for Freelancers in India in 2024: Maximise Your Savings',
    description: "Have you ever had a look at your payslip and wondered where a portion of hard-earned money disappears every month?",
    image: 'https://d17x24txz4ixmz.cloudfront.net/blog/tax-saving-tips-for-freelancers-in-india.webp',
    link: '#'
  },
  {
    title: 'Tax Saving Tips for Freelancers in India in 2024: Maximise Your Savings',
    description: "Have you ever had a look at your payslip and wondered where a portion of hard-earned money disappears every month?",
    image: 'https://d17x24txz4ixmz.cloudfront.net/blog/tax-saving-tips-for-freelancers-in-india.webp',
    link: '#'
  }
];

const Blog = () => {
  return (
    <>
    <Header />
    <div className="new-blog-container p-5">
      <h2 className="new-blog-title text-center mb-4">Blog</h2>
      
      {/* Grid Layout for Blogs */}
      <div className="new-blog-grid row">
        {blogData.map((item, index) => (
          <div key={index} className="new-blog-column col">
            <div className="new-blog-card shadow-sm">
              <img src={item.image} className="new-blog-card-img p-3" alt="Blog visual" />
              <div className="new-blog-card-body">
                <h5 className="new-blog-card-title">{item.title}</h5>
                <p className="new-blog-card-text">{item.description}</p>
                <a href={item.link} className="new-read-more">Read more →</a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
       <Footer />
       </>
  );
};

export default Blog;
